// src/components/ResetPassword.js
import React, { useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { Box, Typography, CircularProgress } from '@mui/material';
import PageSnackbars from '../common/PageSnackbars';
import { usePageSnackbar } from '../common/usePageSnackbar';
import axios from 'axios';
import AuthSplitShell from '../auth/AuthSplitShell';
import { authTitleSx, authSubtitleSx } from '../auth/authSplitShellSx';
import { Input, Button } from '../ui';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ResetPassword = () => {
  const query = useQuery();
  const token = query.get('token');
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { setSuccessMessage, setErrorMessage, snackbarProps } = usePageSnackbar();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setErrorMessage('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      const response = await axios.post('/api/auth/reset-password', { token, password });
      setSuccessMessage(response.data.message || 'Password reset successfully.');
      setTimeout(() => navigate('/login'), 5000);
    } catch (error) {
      setErrorMessage(error.response?.data?.error || 'Failed to reset password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <AuthSplitShell variant="center">
        <Typography component="h1" sx={authTitleSx}>
          Reset password
        </Typography>
        <Typography sx={authSubtitleSx}>
          Enter your new password below.
        </Typography>
        <Box component="form" onSubmit={handleSubmit} sx={{ display: 'grid', gap: 2 }}>
          <Input
            label="New password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="new-password"
          />
          <Input
            label="Confirm password"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            autoComplete="new-password"
          />
          <Button type="submit" fullWidth disabled={loading}>
            {loading ? <CircularProgress size={20} color="inherit" /> : 'Reset password'}
          </Button>
          <Button component={Link} to="/login" variant="outline" fullWidth>
            Back to sign in
          </Button>
        </Box>
      </AuthSplitShell>
      <PageSnackbars
        {...snackbarProps}
        successMessageSuffix=" Redirecting to login in 5 seconds..."
      />
    </>
  );
};

export default ResetPassword;
